import mutations from '@/store/modules/vm/vmCommonState/vm.mutations';
import actions from '@/store/modules/vm/vmCommonState/vm.actions';
import getters from '@/store/modules/vm/vmCommonState/vm.getters';
import { SubTypes } from '@/utils/capabilties/vm/constatnts';
import { Service } from '@/utils/types/global';
export interface NameValue {
  name: String;
  value: String;
}
export interface State {
  currentVm: {
    key: String;
    label: String;
  };
  currentVmService: Service;
  currentVmInstance: {
    key: String;
    label: String;
  };
  vmServices: any[];
  vmSubType: String;
  vmIsActive: Boolean;
  vmAvailability: any;
  attributes: NameValue[];
}

const initialState: State = {
  currentVm: {
    key: '',
    label: ''
  },
  currentVmService: {
    key: '',
    label: '',
    permissions: []
  },
  currentVmInstance: {
    key: '',
    label: ''
  },
  vmServices: [],
  vmSubType: SubTypes.WINDOWS,
  vmIsActive: false,
  vmAvailability: 0,
  attributes: []
};

export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  actions: actions,
  getters
};
